<!-- Rimuovi centrale Modal-->
<template>
    <b-modal
      :visible="visible" 
      @hidden="hide" 
      @change="change"
      @show="fillModal"
      :hide-footer="footer_hide"
      ok-only
      ref="modal"
      id="modal-remove-cu"
      :addCu="addCu"
      :title="$t('remove_cu_modal.title')"
      :ok-title="$t('remove_cu_modal.button_remove_cu')"
      :cancel-title="$t('remove_cu_modal.button_cancel')"
      @ok="handleRemove"
      :state="deenroll_message_parse"
    >
      <b-form-group v-if="form_seen">
        <label class="typo-label" for="label-cu-serial">{{
          $t("id_cu")
        }}</label>
        <b-form-input class="typo-name-label" v-model="cuSerial"></b-form-input>
      </b-form-group>

      <b-form-group v-if="form_seen">
        <label class="typo-label" for="label-cu-type">{{
          $t("details_cu_modal.cu_type")
        }}</label>
        <b-form-input class="typo-name-label" v-model="cuType">
        </b-form-input>
      </b-form-group>

      <b-form-group v-if="form_seen">
        <label class="typo-label" for="label-cu-desc">{{
          $t("details_cu_modal.cu_descrizione")
        }}</label>
        <b-form-input class="typo-name-label" v-model="cuDesc">
        </b-form-input>
      </b-form-group>

      <b-row v-if="confirm_seen" :state="timeout_error">
        <b-col sm="12">
          <div class="text-center">
            <i
              class="fa fa-4x fa-exclamation-triangle"
              style="color: orange"
              aria-hidden="true"
            ></i>
          </div>
          <div class="text-center mt-3 mb-3">
            <strong>{{ $t("central_unit") }} {{ this.cuSerial }}</strong>
          </div>
          <div class="text-center mt-3 mb-3">
            {{ $t("remove_cu_modal.confirm") }}
          </div>
          <div class="d-flex justify-content-center">
            <div v-if="spinner" class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="response_seen">
        <b-col sm="12">
          <div class="text-center">
            <i
              class="fa fa-4x fa-check"
              style="color: green"
              aria-hidden="true"
            ></i>
          </div>
          <div class="text-center mt-3 mb-3">{{ enroll_response }}</div>
        </b-col>
      </b-row>
      <b-row v-if="error_seen">
        <b-col sm="12">
          <div class="text-center">
            <i
              class="fa fa-4x fa-exclamation-triangle"
              style="color: orange"
              aria-hidden="true"
            ></i>
          </div>
          <div class="text-center mt-3 mb-3">{{ enroll_error }}</div>
          <hr>
          <div class="text-center mt-3 mb-3"><b>{{ force_deenroll }}</b></div>

        </b-col>
      </b-row>
    </b-modal>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "RemoveCentralUnit",
  model: {
    prop: "visible",
    event: "change"
  },
  props: {
    cu: {
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cuSerial: "",
      cuType: "",
      cuDesc:"",
      addCu: "false",
      confirm: 0,
      response_seen: false,
      error_seen: false,
      footer_hide: false,
      confirm_seen: false,
      form_seen: true,
      enroll_error: null,
      enroll_response: null,
      force_deenroll:null,
      spinner: false,
      plantUnits: this.$store.state.plantUnits,
      timerTimeout: 5,
    };
  },
 computed: {
    deenroll_message_parse() {
      //Check if there's a response of enroll command
      if (
        this.$store.state.commandResponse.pending != true &&
        this.$store.state.commandResponse.command == "DEENROLL"
      ) {
        this.form_seen = false;
        this.spinner = false;
        this.footer_hide = true;
        this.confirm_seen = false;
        this.response_seen = true;
        this.enroll_response =
          this.$t("central_unit") +
          " " +
          this.cuSerial +
          " " +
          this.$t("remove_cu_modal.deenroll_ok");

        //remove cu
        this.$store.dispatch("dbRemoveCu", {
          serial: this.cuSerial,
          type: this.cuType,
          plant: this.$store.state.currentPlant.id,
        });

        //define route path
        let path_devices = "/plant/" + this.$store.state.currentPlant.id;

        //send to main page
        setTimeout(() => {
          this.$store.state.commandResponse = {
            pending: false,
            cu: null,
            command: null,
            response: null,
            error: null,
          };
          this.$store.dispatch('loadUnitsDetails', this.$store.state.currentPlant.id);
        }, 1500);

        // Hide the modal manually
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });

      }
    },
    timeout_error() {
      //Check if there's a timeout
      if (this.timerTimeout == 0) {
        this.confirm_seen = false;
        this.error_seen = true;
        this.enroll_error = this.$t("remove_cu_modal.error_timeout");
        this.force_deenroll = this.$t("remove_cu_modal.force_deenroll");
        this.footer_hide=false;
        this.spinner = false;
      }
    },
  },
  methods: {
    hide() {
      this.$emit("hide");
    },
    change(visible) {
      this.$emit("change", visible);
    },
    fillModal() {
      this.cuType="";
      this.cuSerial="";
      this.cuDesc="";
      if(this.cu)
      {
        this.cuType=this.cu.cu_type;
        this.cuSerial=this.cu.cu_id;
        this.cuDesc=this.cu.cu_desc;
      }
      this.response_seen = false;
      this.error_seen = false;
      this.footer_hide = false;
      this.form_seen = true;
      this.confirm_seen = false;
      this.error_seen = false;
      this.spinner = false;
      this.confirm = 0;
      this.enroll_error="";
    },
    handleRemove(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();

      if(this.enroll_error==null || this.enroll_error=="")
      {
      // La centrale potrebbe essere raggiungibile ed invio un deenroll command
      if (this.confirm == 0) {
        this.form_seen = false;
        this.confirm_seen = true;
      }
      if (this.confirm == 1) {
        console.log("CONFIRM: ", confirm);
        this.spinner = true;
        this.timerTimeout = 5;
        this.footer_hide = true;
        this.enroll_error = "";
        this.force_deenroll="";
        this.TimeoutTimer();
        this.$store.dispatch("deEnrollCu", {
          serial: this.cuSerial,
          type: this.cuType,
        });
      }
      this.confirm++;
      }
      // La centrale non è raggiungibile quindi forzo manualmente un remove cu
      else{
        //remove cu
        this.$store.dispatch("dbRemoveCu", {
          serial: this.cuSerial,
          type: this.cuType,
          plant: this.$store.state.currentPlant.id,
        });

        //define route path
        //let path_devices = "/plant/" + this.$store.state.currentPlant.id;

        //send to main page
        setTimeout(() => {
          this.$store.state.commandResponse = {
            pending: false,
            cu: null,
            command: null,
            response: null,
            error: null,
          };
          //this.$router.push({ path: path_devices });
          this.$router.go();
        }, 1500);
      }
  
    },

    TimeoutTimer() {
      if (this.timerTimeout > 0) {
        setTimeout(() => {
          this.timerTimeout -= 1;
          console.log(this.timerTimeout);
          this.TimeoutTimer();
        }, 1000);
      }
    },

  },
};
</script>
